module.exports = __webpack_public_path__ + "static/img/m3.0181ccf.png";


//////////////////
// WEBPACK FOOTER
// ./src/apps/swee/assets/cluster/m3.png
// module id = FgY9
// module chunks = 13